<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.listaSolicitari')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaClient')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off"
                                @change="applyQuery({ q: search })"
                        >
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}}: "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
            <div class="mobile-sort-by">
                <v-select :options="this.mobileSorting"
                          v-model="sortMobile.sortMobileBy"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="name"
                          :placeholder="$t('txt.sorteazaDupa')">
                </v-select>
            </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType"
                          v-model="sortMobile.sortMobileType"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="name"
                          :placeholder="$t('txt.criteriuSortare')">
                </v-select>
            </div>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col" @click="handleSort('id')"> {{$t('tableHeader.id')}}</th>
                <th scope="col" @click="handleSort('first_name')"> {{$t('tableHeader.nume')}}</th>
                <th scope="col" @click="handleSort('last_name')"> {{$t('tableHeader.prenume')}}</th>
                <th scope="col" @click="handleSort('type')"> {{$t('tableHeader.produsDorit')}}</th>
                <th scope="col" @click="handleSort('company_name')"> {{$t('tableHeader.puncte')}}</th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="requests">
            <tr v-for="(request, index) in requests" :key="index">
                <td :tableheadData="$t('tableHeader.id')"> {{(request.id) ? request.id : '-'}}</td>
                <td :tableheadData="$t('tableHeader.nume')"> {{(request.user.first_name) ? request.user.first_name : '-'}}</td>
                <td :tableheadData="$t('tableHeader.prenume')"> {{(request.user.last_name) ? request.user.last_name : '-'}}</td>
                <td :tableheadData="$t('tableHeader.produsDorit')"> {{(request.prize) ? request.prize.title : '-'}}</td>
                <td :tableheadData="$t('tableHeader.puncte')"> {{(request.points) ? request.points: '-'}}</td>
                <td :tableheadData="$t('tableHeader.optiuni')" class="options-case">
                    <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip"
                       :title="$t('placeholder.aproba')" @click="approveRequest(index, request.id)">
                        <i class="fas fa-check-double"></i>
                    </a>
                    <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip"
                       :title="$t('placeholder.respinge')" @click="denyRequest(index, request.id)">
                        <i class="fas fa-minus-circle"></i>
                    </a>
                </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
                <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
            </tr>
            </tbody>
            <tfoot v-if="requests">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.id')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.nume')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.prenume')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.produsDorit')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.puncte')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="requests">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import PrizesService from '../../api-services/prizes.service.js'
export default {
  name: 'Requests',
  data () {
    return {
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      mobileSorting: [
        { key: 'first_name', name: 'Nume' },
        { key: 'last_name', name: 'Prenume' },
        { key: 'type', name: 'Tip Persoana' },
        { key: 'company_name', name: 'Companie' },
        { key: 'phone', name: 'Telefon' },
        { key: 'city', name: 'Oras' },
        { key: 'county', name: 'Judet' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      requests: [],
      meta: [],
      search: '',
      searchBy: this.$route.query.q || null,
      filters: {
        per_page: 25
      }
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      this.getPrizes()
    }
  },
  computed: {
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.key : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },
    // return first page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return this.meta.current_page - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return this.meta.current_page + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    getPrizes () {
      PrizesService.getRequests()
        .then((response) => {
          this.requests = response.data.data
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    denyRequest (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.refuzaCererea'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          let data = {
            id: id
          }
          PrizesService.denyRequest(data)
            .then((response) => {
              if (response.data.status === 200) {
                let request = this.requests.find(request => request.id === id)
                this.$delete(this.requests, index)
                this.$store.getters.user.points += request.points
                localStorage.setItem('user', JSON.stringify(this.$store.getters.user))
              }
            })
            .catch((error) => {
              if (error.response) {
                let message = error.response.data.error
                this.$notify({
                  group: 'error',
                  type: 'error',
                  title: 'Error',
                  text: message,
                  'animation-type': 'css'
                })
              }
            })
        }
      })
    },
    approveRequest (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.aprobaCererea'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          let data = {
            id: id
          }
          PrizesService.approveRequest(data)
            .then((response) => {
              if (response.data.status === 200) {
                this.$notify({
                  group: 'succes',
                  type: 'success',
                  // title: 'Added',
                  text: this.$t('success.cerereAprobata'),
                  'animation-type': 'css'
                })
              }
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'prizesrequests', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    let query = this.$route.query
    if (query.q) this.search = query.q
    this.getPrizes()
  }
}
</script>
